import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import NightspotRequests from "../NightspotRequests";
import { Puff } from "react-loading-icons";
import NavBar from "../../../../components/NavBar";
import { Grid } from "../../../Layout/Grid/GridView";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Slider from '@mui/material/Slider';
import { Input } from "../../../Layout/Forms/Form";
import Request from "../../../../api/Requests";
import { toast } from "react-toastify";
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import "./WalletBuyCredits.css";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const StripePaymentForm = ({ clientSecret, valueTotal, onSuccess }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsProcessing(true);

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
                return_url: process.env.REACT_APP_API_URL + "index.php?r=", // Adjust as needed
            },
            redirect: 'if_required'
        });

        if (error) {
            setMessage(error.message);
            toast.error(error.message, { theme: "dark" });
        } else if (paymentIntent && paymentIntent.status === 'succeeded') {
            setMessage("Payment succeeded!");
            onSuccess(paymentIntent);
        } else {
            setMessage("Unexpected state.");
        }

        setIsProcessing(false);
    };

    return (
        <form onSubmit={handleSubmit} className="animate-fade-in mt-3">
            <PaymentElement />
            <button
                disabled={isProcessing || !stripe || !elements}
                id="submit"
                className="action-button mt-4"
            >
                <span id="button-text">
                    {isProcessing ? "Processing..." : `Pagar ${valueTotal}€`}
                </span>
            </button>
            {message && <div id="payment-message" className="text-danger mt-2">{message}</div>}
        </form>
    );
};

const WalletBuyCredits = () => {
    const gridRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    let params = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({
        form: {
            credit_value: 750,
            value_total: 0,
            payment_method: 'MBWAY',
            phone_country: '+351',
            phone_number: '',
        },
    });

    const [stripKey, setstripKey] = useState({
        client_secret: ''
    })
    const [isStripeLoading, setIsStripeLoading] = useState(false);

    const optionsStripe = {
        clientSecret: stripKey.client_secret,
        appearance: {
            theme: 'night',
            variables: {
                colorPrimary: '#11cb5f',
                colorBackground: '#1a1f2a',
                colorText: '#ffffff',
                colorDanger: '#df1b41',
                fontFamily: 'Inter, system-ui, sans-serif',
                spacingUnit: '4px',
                borderRadius: '8px',
            },
        },
    };

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    useEffect(() => {
        calculatePrice(state.form.credit_value);
    }, [state.form.credit_value]);

    // Fetch PaymentIntent when switching to Stripe
    useEffect(() => {
        if (state.form.payment_method === 'STRIPE' && !stripKey.client_secret) {
            fetchPaymentIntent();
        }
    }, [state.form.payment_method]);

    const calculatePrice = (quantidade) => {
        const precoMaximo = 0.06;
        const precoMinimo = 0.02925;
        const quantidadeMinima = 200;
        const quantidadeMaxima = 10000;

        const k = Math.log(100) / (quantidadeMaxima - quantidadeMinima);

        if (quantidade < quantidadeMinima) {
            quantidade = quantidadeMinima;
        }

        const preco = precoMinimo + (precoMaximo - precoMinimo) * Math.exp(-k * (quantidade - quantidadeMinima));
        const total = (preco * quantidade).toFixed(2);
        handleChangeInputs({ target: { name: 'value_total', value: Math.ceil(total) } });
    };

    const fetchPaymentIntent = async () => {
        setIsStripeLoading(true);
        // Ensure we have the latest value_total. 
        // Note: state.form.value_total might be stale if called immediately after slider change, 
        // but calculatePrice updates it.

        // We need to recalculate locally or ensure state is updated to send correct amount
        // For safety, let's trust state.form.value_total is up to date or passed as arg if needed.

        const response = await Request("venues/wallet-payment-intent", "POST", { ...state.form, id_venues: params.id, payment_method: 'STRIPE' }, true);

        if (response && response.status && response.data.client_secret) {
            setstripKey({ client_secret: response.data.client_secret });
        } else {
            toast.error("Erro ao iniciar pagamento Stripe", { theme: "dark" });
        }
        setIsStripeLoading(false);
    };

    const handleSliderCommit = (event, newValue) => {
        // When slider is released, if Stripe is selected, update the intent
        if (state.form.payment_method === 'STRIPE') {
            // We need to wait for the value_total to be updated by the useEffect -> calculatePrice cycle
            // Or we can just call fetchPaymentIntent with a small delay or pass the new value directly.
            // Since calculatePrice runs on render/effect, it should be fast. 
            // However, to be safe, we can just call fetchPaymentIntent.
            // But wait, calculatePrice updates state, which triggers re-render.
            // Let's just call fetchPaymentIntent.
            setTimeout(() => fetchPaymentIntent(), 100);
        }
    };

    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#11cb5f" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                        marginTop: "1rem",
                        color: "#fff"
                    }}
                >
                    Loading...
                </div>
            </div>
        );
    };

    const theme = createTheme({
        components: {
            MuiSlider: {
                styleOverrides: {
                    root: {
                        color: '#11cb5f',
                        height: 8,
                    },
                    thumb: {
                        height: 24,
                        width: 24,
                        backgroundColor: '#fff',
                        border: '2px solid currentColor',
                        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                            boxShadow: 'inherit',
                        },
                        '&:before': {
                            display: 'none',
                        },
                    },
                    valueLabel: {
                        lineHeight: 1.2,
                        fontSize: 12,
                        background: 'unset',
                        padding: 0,
                        width: 32,
                        height: 32,
                        borderRadius: '50% 50% 50% 0',
                        backgroundColor: '#11cb5f',
                        transformOrigin: 'bottom left',
                        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
                        '&:before': { display: 'none' },
                        '&.MuiSlider-valueLabelOpen': {
                            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
                        },
                        '& > *': {
                            transform: 'rotate(45deg)',
                        },
                    },
                    markLabel: {
                        color: '#a5a5a5',
                        fontSize: '0.8rem',
                    },
                    rail: {
                        opacity: 0.3,
                        backgroundColor: '#fff',
                    },
                },
            },
        },
    });

    const marksPercentagePrePayment = [
        { value: 250, label: '250' },
        { value: 750, label: '750' },
        { value: 1500, label: '1500' },
        { value: 3000, label: '3000' },
        { value: 5000, label: '5000' },
    ];

    const handlerCheckOutMBWAY = async () => {
        let errorArray = {};
        let error = false;

        if (state.form.phone_number.trim().length == 0) {
            errorArray = {
                ...errorArray,
                ...{
                    phone_number: [
                        'Preenche o Nº Telemóvel'
                    ]
                }
            }
            error = true;
        }

        if (state.form.phone_number.trim().length !== 9) {
            errorArray = {
                ...errorArray,
                ...{
                    phone_number: [
                        'Nº Telemóvel inválido'
                    ]
                }
            }
            error = true;
        }

        if (error) {
            toast.error("Preencha os campos obrigatórios", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });

            setState({
                ...state,
                errors: errorArray
            })
            return false;
        }

        setIsLoading(true);
        const response = await Request("venues/wallet-deposit", "POST", { ...state.form, id_venues: params.id }, true);

        if (response && response.status) {
            navigate(`/my/nightspots/${params.id}/wallet/transaction/${response.data.transaction_id}`);
        } else {
            toast.error(response.error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        }
        setIsLoading(false);
    }

    const handleStripeSuccess = (paymentIntent) => {
        // Navigate to success page or transaction page
        // Assuming we get a transaction ID or just redirect to wallet
        navigate(`/my/nightspots/${params.id}/wallet`);
        toast.success("Pagamento efetuado com sucesso!", { theme: "dark" });
    };


    return (
        <div>
            <NavBar>
                <div className="wallet-buy-credits-container">
                    {isLoading ? (
                        <InsideLoading />
                    ) : (
                        <>
                            <div className="row mb-4">
                                <div className="col-12">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/my/dashboard" className="text-muted text-decoration-none">
                                                    <i className="fa-solid fa-home"></i>
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to="/my/nightspots/" className="text-muted text-decoration-none">Nightspots</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to={`/my/nightspots/${params.id}/wallet`} className="text-muted text-decoration-none">Wallet</Link>
                                            </li>
                                            <li className="breadcrumb-item active text-white" aria-current="page">
                                                Carregar créditos
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>

                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-9">
                                    <div className="glass-panel">
                                        <div className="page-header">
                                            <h2 className="page-title">Carregar Créditos</h2>
                                            <p className="page-subtitle">Escolha o pacote de créditos ideal para as suas campanhas de SMS.</p>
                                        </div>

                                        <div className="row g-5">
                                            <div className="col-md-8">
                                                <div className="credits-slider-section">
                                                    <label className="section-label">Quantidade de Créditos</label>
                                                    <div className="px-3 py-4">
                                                        <ThemeProvider theme={theme}>
                                                            <Slider
                                                                getAriaLabel={() => 'Valor'}
                                                                value={state.form.credit_value}
                                                                name='credit_value'
                                                                onChange={handleChangeInputs}
                                                                onChangeCommitted={handleSliderCommit}
                                                                min={250}
                                                                max={5000}
                                                                step={null}
                                                                valueLabelDisplay="on"
                                                                marks={marksPercentagePrePayment}
                                                            />
                                                        </ThemeProvider>
                                                    </div>
                                                </div>

                                                <div className="payment-method-section">
                                                    <label className="section-label">Método de Pagamento</label>

                                                    <div
                                                        className={`payment-option mb-3 ${state.form.payment_method === 'MBWAY' ? 'selected' : ''}`}
                                                        onClick={() => setState({ ...state, form: { ...state.form, payment_method: 'MBWAY' } })}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center gap-3">
                                                                <input
                                                                    className="form-check-input mt-0"
                                                                    type="radio"
                                                                    checked={state.form.payment_method === 'MBWAY'}
                                                                    readOnly
                                                                    style={{ accentColor: '#11cb5f', width: '20px', height: '20px' }}
                                                                />
                                                                <img src="/img/payments/mbway.png" alt="MBWAY" className="payment-logo" />
                                                            </div>
                                                            <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25">Recomendado</span>
                                                        </div>

                                                        {state.form.payment_method === 'MBWAY' && (
                                                            <div className="custom-input-group animate-fade-in">
                                                                <Input
                                                                    label="Número de telemóvel"
                                                                    name="phone_number"
                                                                    value={state.form.phone_number}
                                                                    onChange={handleChangeInputs}
                                                                    type="number"
                                                                    errors={state.errors}
                                                                    placeholder="912 345 678"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div
                                                        className={`payment-option ${state.form.payment_method === 'STRIPE' ? 'selected' : ''}`}
                                                        onClick={() => setState({ ...state, form: { ...state.form, payment_method: 'STRIPE' } })}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center gap-3">
                                                                <input
                                                                    className="form-check-input mt-0"
                                                                    type="radio"
                                                                    checked={state.form.payment_method === 'STRIPE'}
                                                                    readOnly
                                                                    style={{ accentColor: '#11cb5f', width: '20px', height: '20px' }}
                                                                />
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <img src="/img/payments/apple-pay.png" alt="Apple Pay" style={{ height: '24px' }} />
                                                                    <img src="/img/payments/google-pay.png" alt="Google Pay" style={{ height: '24px' }} />
                                                                    <img src="/img/payments/mastercard.png" alt="Mastercard" style={{ height: '24px' }} />
                                                                    <img src="/img/payments/visa.png" alt="Visa" style={{ height: '24px' }} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {state.form.payment_method === 'STRIPE' && (
                                                            <div className="mt-3 animate-fade-in">
                                                                {isStripeLoading ? (
                                                                    <div className="text-center py-3">
                                                                        <Puff stroke="#11cb5f" height="2em" width="2em" />
                                                                    </div>
                                                                ) : stripKey.client_secret ? (
                                                                    <Elements stripe={stripePromise} options={optionsStripe}>
                                                                        <StripePaymentForm
                                                                            clientSecret={stripKey.client_secret}
                                                                            valueTotal={state.form.value_total}
                                                                            onSuccess={handleStripeSuccess}
                                                                        />
                                                                    </Elements>
                                                                ) : (
                                                                    <div className="text-center text-muted py-2">
                                                                        A iniciar pagamento seguro...
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="summary-card mb-4">
                                                    <div>
                                                        <div className="summary-label">Total a Pagar</div>
                                                        <div className="summary-value">{state.form.value_total}€</div>
                                                    </div>
                                                    <div className="currency-icon">
                                                        <i className="fas fa-euro-sign"></i>
                                                    </div>
                                                </div>

                                                <div className="glass-panel p-4" style={{ background: 'rgba(0,0,0,0.2)' }}>
                                                    <h5 className="text-white mb-3" style={{ fontSize: '1.1rem' }}>Resumo</h5>
                                                    <div className="d-flex justify-content-between mb-2 text-muted">
                                                        <span>Créditos</span>
                                                        <span className="text-white">{state.form.credit_value}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between mb-2 text-muted">
                                                        <span>Preço / SMS</span>
                                                        <span className="text-white">~{(state.form.value_total / state.form.credit_value).toFixed(3)}€</span>
                                                    </div>
                                                    <hr style={{ borderColor: 'rgba(255,255,255,0.1)' }} />
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="fw-bold text-white">Total</span>
                                                        <span className="fw-bold text-success fs-4">{state.form.value_total}€</span>
                                                    </div>
                                                </div>

                                                {state.form.payment_method === 'MBWAY' && (
                                                    <button className="action-button" onClick={handlerCheckOutMBWAY}>
                                                        Pagar com MBWAY <i className="fas fa-arrow-right ms-2"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </NavBar >
        </div >
    );
};

export default WalletBuyCredits;